/* eslint-disable indent */
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';

import { COLORS } from 'theme';

export const StyledDialogTitle = styled(DialogTitle)`
  && {
    display: flex;
    align-items: center;
    width: 100%;
    padding: ${({ theme }) => `${theme.spacing.m2}`};
    font-size: ${({ theme }) => theme.fontSize.h2};
    line-height: ${({ theme }) => theme.lineHeight.h2};

    ${({ $border }) =>
      $border &&
      `
      border-bottom: 1px solid ${COLORS.black10};
    `}

    ${({ $noMargin }) => $noMargin && 'margin: 0;'}
  }
`;

export const CloseIconContainer = styled.div`
  align-self: start;
  margin-left: auto;
  padding-left: ${({ theme }) => theme.spacing.m1};
  height: ${({ theme }) => theme.spacing.m4};
  display: flex;

  && {
    svg {
      font-size: 20px;
    }
  }
`;

export const StyledTitleContent = styled.div`
  width: 100%;
  display: flex;
`;
